import { ApiRequestErrorNetworkBackend } from './ApiRequestError'

export const parseApiRequestErrorMessage = (
  error: unknown,
  fallbackMessage: string,
) => {
  if (error instanceof ApiRequestErrorNetworkBackend)
    return error.dynamicError.detailed_error_description
  return fallbackMessage
}
